(() => {
  const modal = document.querySelector('[data-lbc-size-guide-modal]');
  if (!modal) return;

  const dialog = modal.querySelector('.lbc-size-guide-modal__dialog');
  const openers = document.querySelectorAll('[data-lbc-size-guide-open]');
  const closers = modal.querySelectorAll('[data-lbc-size-guide-close]');
  let lastFocusedElement = null;

  const openModal = () => {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(() => dialog && dialog.focus(), 0);
  };

  const closeModal = () => {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  };

  openers.forEach((button) => button.addEventListener('click', openModal));
  closers.forEach((button) => button.addEventListener('click', closeModal));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  const sizeChart = [
    { label: '34 / XS', bust: 34, waist: 30, hip: 36 },
    { label: '36 / S', bust: 36, waist: 32, hip: 38 },
    { label: '38 / M', bust: 38, waist: 34, hip: 40 },
    { label: '40 / L', bust: 40, waist: 36, hip: 42 },
    { label: '42 / XL', bust: 42, waist: 38, hip: 44 },
    { label: '44 / 2XL / XXL', bust: 44, waist: 40, hip: 46 },
    { label: '46 / 3XL', bust: 46, waist: 42, hip: 48 },
    { label: '48 / 4XL', bust: 48, waist: 44, hip: 50 }
  ];

  const toNumber = (value) => {
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : null;
  };

  document.querySelectorAll('[data-lbc-size-recommender]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const data = new FormData(form);
      const bust = toNumber(data.get('bust'));
      const waist = toNumber(data.get('waist'));
      const hip = toNumber(data.get('hip'));
      const height = toNumber(data.get('height'));
      const fit = data.get('fit') || 'regular';
      const result = form.querySelector('[data-lbc-size-result]');

      if (!result) return;

      if (!bust) {
        result.textContent = 'Please enter your bust measurement to suggest the best size.';
        result.classList.add('is-visible');
        return;
      }

      let index = sizeChart.findIndex((size) => {
        const bustOk = bust <= size.bust;
        const waistOk = !waist || waist <= size.waist;
        const hipOk = !hip || hip <= size.hip;
        return bustOk && waistOk && hipOk;
      });

      if (index === -1) index = sizeChart.length - 1;
      if (fit === 'relaxed' && index < sizeChart.length - 1) index += 1;
      if (fit === 'slim' && index > 0 && bust <= sizeChart[index - 1].bust) index -= 1;

      const recommended = sizeChart[index];
      const next = sizeChart[index + 1];

      let message = `Recommended size: ${recommended.label}.`;
      if (fit !== 'slim' && next) {
        message += ` For extra comfort, you may also consider ${next.label}.`;
      }
      if (height && height > 165) {
        message += ' Please also check kurti length in the product details.';
      }
      message += ' For alpha labels like S/M/L, use the matching size shown in the table. For final confirmation, WhatsApp your measurements to us.';

      result.textContent = message;
      result.classList.add('is-visible');
    });
  });
})();